// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Ws0A","content":"styles_content__1-xFl","checkbox":"styles_checkbox__2YD0y","checkboxLabel":"styles_checkboxLabel__iAYCR"};